<template>
  <div>
<!--    <file-Upload :url="form.courseCover" :showFileList="false" @getUrl="getXunZh"></file-Upload>-->
    <div style="width: 60%;min-width: 1050px; margin: 0 auto;background: #ffffff">
      <div class="flex flex-between flex-align-center global-padd">
        <div class="font-18 font-bold">
          组织管理
        </div>
        <div>
<!--          <el-button type="primary" size="small" @click="create">-->
<!--            <i class="el-icon-plus" style="margin-right: 5px"></i>上传文档-->
<!--          </el-button>-->
        </div>
      </div>
      <div class="global-line"></div>
      <div class="global-padd-15">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="基本信息" name="first"></el-tab-pane>
          <el-tab-pane label="缴费设置" name="second"></el-tab-pane>
        </el-tabs>
      </div>
      <div style="padding: 0 15px">
        <el-form v-if="activeName=='first'" key="ruleForm" :model="form" :inline="true" label-width="230px" :rules="rules" ref="ruleForm">
          <el-form-item label="组织名称："  prop="orgName" style="width: 100%">
            <el-input size="small" placeholder="请输入组织名称"
                      v-model="form.orgName"
                      style="width: 300px" clearable></el-input>
          </el-form-item>
          <el-form-item label="logo："   style="width: 100%">
            <img-Upload :url="logo" :showFileList="false" @getUrl="getLogo"></img-Upload>
          </el-form-item>
          <el-form-item label="负责人："  prop="leaderName" style="width: 100%">
            <el-input size="small" placeholder="请输入负责人"
                      v-model="form.leaderName"
                      style="width: 300px" clearable></el-input>
          </el-form-item>
          <el-form-item label="电话："  prop="leaderPhone" style="width: 100%">
            <el-input size="small" placeholder="请输入电话号码"
                      v-model="form.leaderPhone"
                      type="number"
                      style="width: 300px" clearable></el-input>
          </el-form-item>

          <!--        <el-form-item label="知识类型：" required prop="type">-->
          <!--          <el-select size="small"-->
          <!--                     clearable-->
          <!--                     v-model="form.type">-->
          <!--            <el-option :label="item" :key="index" :disabled="(index=='document'||index=='news')?true:false" :value="index" v-for="(item,index) in tagList"></el-option>-->
          <!--          </el-select>-->
          <!--        </el-form-item>-->
          <el-form-item label="组织介绍："  prop="orgIntro" style="width: 100%" >
            <el-input placeholder="请输入组织介绍"
                      v-model="form.orgIntro"
                      rows="5"
                      clearable
                      type="textarea"
                      maxlength="100000"
                      show-word-limit
                      style="width: 500px" ></el-input>
          </el-form-item>
          <el-form-item label="组织地址："  prop="orgAddress" style="width: 100%">
            <el-input size="small" placeholder="请输入组织地址"
                      v-model="form.orgAddress"
                      style="width: 500px" clearable></el-input>
          </el-form-item>
        </el-form>
        <el-form v-if="activeName=='second'" key="ruleFormPay" :model="formPay" :inline="true" label-width="230px" :rules="rulesPay" ref="ruleFormPay">
          <div class="title-1">缴费规则设置</div>
          <div class="global-line margin-bottom-20"></div>
          <el-form-item label="会费缴纳日期：" prop="value1"  style="width: 100%">
            <el-date-picker
                v-model="value1"
                type="daterange"
                align="right"
                unlink-panels
                value-format="timestamp"
                range-separator="至"
                @change="getTimepay"
                :picker-options="pickerOptions"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <div class="title-1">团体会费缴纳账户设置</div>
          <div class="global-line margin-bottom-20"></div>
          <el-form-item label="户名："  prop="accountName" style="width: 100%">
            <el-input size="small" placeholder="请输入户名"
                      v-model="formPay.accountName"
                      style="width: 300px" clearable></el-input>
          </el-form-item>
          <el-form-item label="账户："  prop="accountNumber" style="width: 100%">
            <el-input size="small" placeholder="请输入账户号码"
                      v-model="formPay.accountNumber"
                      type="number"
                      style="width: 300px" clearable></el-input>
          </el-form-item>
          <el-form-item label="开户行："  prop="bankName" style="width: 100%">
            <el-input size="small" placeholder="请输入开户行"
                      v-model="formPay.bankName"
                      style="width: 300px" clearable></el-input>
          </el-form-item>

          <!--        <el-form-item label="知识类型：" required prop="type">-->
          <!--          <el-select size="small"-->
          <!--                     clearable-->
          <!--                     v-model="form.type">-->
          <!--            <el-option :label="item" :key="index" :disabled="(index=='document'||index=='news')?true:false" :value="index" v-for="(item,index) in tagList"></el-option>-->
          <!--          </el-select>-->
          <!--        </el-form-item>-->
          <el-form-item label="会费收取标准："  prop="chargingStandards" style="width: 100%" >
            <el-input placeholder="请输入会费收取标准"
                      v-model="formPay.chargingStandards"
                      rows="5"
                      clearable
                      type="textarea"
                      maxlength="100000"
                      show-word-limit
                      style="width: 500px" ></el-input>
          </el-form-item>
          <el-form-item label="协会地址及工作人员联系方式："  prop="otherInfo" style="width: 100%" >
            <el-input placeholder="请输入协会地址及工作人员联系方式"
                      v-model="formPay.otherInfo"
                      rows="5"
                      clearable
                      type="textarea"
                      maxlength="100000"
                      show-word-limit
                      style="width: 500px" ></el-input>
          </el-form-item>

        </el-form>
      </div>
  <div style="padding: 20px;display: flex;justify-content: flex-end">
<!--        <el-button @click="menuBack">取消</el-button>-->
        <el-button v-if="activeName=='first'" type="primary"  @click="save('ruleForm')" >提交</el-button>
        <el-button v-if="activeName=='second'" type="primary"  @click="savePay('ruleFormPay')" >提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import imgUpload from '@/components/EeUpload'
export default {
  name: 'AICreateDOC',
  components: {
    imgUpload
  },
  data () {
    return {
      value1:[],
      pickerOptions: {
        shortcuts: [{
          text: '一年期限',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            end.setMonth(start.getMonth() + 12);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      logo:'',
      activeName:'first',
      tagList:[],
      formPay:{
        value1:[],
        accountName:'',
        accountNumber:'',
        bankName:'',
        chargingStandards:'',
        otherInfo:'',
      },
      form:{
        orgAddress:undefined,
        orgName:undefined,
        leaderName:undefined,
        leaderPhone:undefined,
        orgIntro:undefined,
        logo:''
      },
      rulesPay: {
        'value1': [
          { required: true, message: '请选择会费缴纳日期'},
        ],
        'accountName': [
          { required: true, message: '请输入户名'},
        ],
        'accountNumber': [
          { required: true, message: '请输入账户号'},
        ],
        'bankName': [
          { required: true, message: '请输入开户行'},
        ],
        'chargingStandards': [
          { required: true, message: '请输入会费收费标准'},
        ],
        'otherInfo': [
          { required: true, message: '请输入协会地址及工作人员联系方式'},
        ],
      },
      rules: {
        'orgName': [
          { required: true, message: '请输入组织名称'},
        ],
        'leaderName': [
          { required: true, message: '请输入负责人'},
        ],
        'leaderPhone': [
          { required: true, message: '请输入负责人电话'},
        ],
        // 'content': [
        //   { required: true, message: '知识内容不能为空' },
        //   { min: 0, max: 100000, message: '长度在不超过10万字'}
        // ]
      },
    }
  },
  watch: {
    // 监听路由变化，改变页面内容
    // '$route' (to, from) {
      // this.isCreate = to.params.type === 'create'
      // if (!this.isCreate) {
      //   this.loadProductDetail(this.$route.params.type)
      // } else {
      //   this.realProductUrl = undefined
      //   this.disable = false
      //   this.productInfo = {}
      //   this.productPrice = 0
      // }
    // }
  },
  mounted () {
    // this.form.id=this.$route.params.id || undefined
    // if( this.form.id){
      this.getDetail()
    // }
    // this.getTagList()
  },
  methods: {
    getLogo(a){
      console.log(a)
      this.form.logo=a
    },
    getTimepay(val){
      console.log(val)
      this.formPay.value1=val
      this.formPay.payTimeBegin=val[0]
      this.formPay.payTimeEnd=val[1]
    },
    handleClick(tab, event) {
      console.log(tab.name);
      if(tab.name=='first'){
        this.getDetail()
      }else{
        this.getDetailPay()
      }
    },
    getDetail(){
      this.$http.post('/rest/system/setting/base', {}, res => {
        this.form=res
        this.logo=res.logo
      })
    },
    getDetailPay(){
      this.$http.post('/rest/system/setting/pay', {}, res => {
        this.formPay=res
        this.value1=[res.payTimeBegin,res.payTimeEnd]
        this.formPay.value1=[res.payTimeBegin,res.payTimeEnd]
        // this.formPay.payTimeBegin=res.payTimeBegin
        // this.formPay.payTimeEnd=res.payTimeEnd
      })
    },
    savePay(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading =this.$loading({
            text:"提交中请您耐心等待"
          })
          this.$http.postJson('/rest/system/setting/pay/modify', this.formPay, res => {
            loading.close();
            this.$message({
              type: 'success',
              message: "已提交！"
            });
            // this.$router.push('/AILibrary/list')
          },(err)=>{
            loading.close();
          })
        }
      });
    },
    save(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading =this.$loading({
            text:"提交中请您耐心等待"
          })
          this.$http.postJson('/rest/system/setting/base/modify', this.form, res => {
            loading.close();
            this.$message({
              type: 'success',
              message: "已提交！"
            });
            // this.$router.push('/AILibrary/list')
          },(err)=>{
            loading.close();
          })
        }
      });

    },
    // getTagList(){
    //   this.$http.post('/service-fire-qa/rest/public/data/knowledge/type', null, res => {
    //     this.tagList = res
    //   })
    // }

  }
}
</script>

<style scoped>
/*.create-product-li {*/
/*  .el-form {*/
/*    padding 20px*/
/*  }*/
/*}*/
/deep/ .el-textarea .el-input__count{
  right: 20px!important;
}
/deep/ .el-tabs__item{
  font-size: 16px!important;
  font-weight: bold;
}
.title-1{
  font-size: 16px;
  margin-bottom: 10px;
  border-left: 3px solid #4680FE;
  padding-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/view/operationManagement/orgManagement/index.vue